document.addEventListener("DOMContentLoaded", () => {
  console.log(window.innerWidth, "width");
  if (window.innerWidth < 768) {
    let sectionMoved = false;
    const observer = new MutationObserver(() => {
      if (document.body.hasAttribute("data-ab-atc") && !sectionMoved) {
        sectionMoved = true;
        const mainContent = document.querySelector("main");
        const firstSection = mainContent.firstElementChild;
        const newArrivals = document.querySelector(".new-arrivals").parentNode;

        mainContent.insertBefore(newArrivals, firstSection.nextElementSibling);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      childList: false,
      subtree: false,
    });
  }
});
